import * as React from 'react';
import { Helmet } from 'react-helmet';

interface Props {
  title: string;
}

export function Title({ title }: Props) {
  if (!title) return <></>;

  return (
    <Helmet>
      <title>{`REQpay | ${title}`}</title>
    </Helmet>
  );
}
